import { service } from '@ember/service';

import BaseAbility from 'umg-ember-backend/abilities/base';

export default class SftpUserAbility extends BaseAbility {
  // Services
  @service permission;

  // Getter and setter
  get canUpdate() {
    let isOwn = this.permission.sftpUsers.find((sftpUser) => {
      return sftpUser.id === this.model?.id;
    });

    return this.actions?.update || isOwn;
  }
}
